import {useAuth} from '@apps-common/auth-react';
import {useTheme} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import Joyride, {ACTIONS, EVENTS, STATUS} from 'react-joyride';
import {connect} from 'react-redux';

import TourCard from './tour-card.jsx';
import {setAccessPermissions} from '@explorer/actions/search-filters.js';
import {endTour, setupTourStage} from '@explorer/actions/tour';
import {trackEvent} from '@explorer/analytics';
import {TOURS} from '@explorer/constants/tour.js';
import {isTrialUser} from '@explorer/util/user.js';

const Tour = ({endTour, setupTourStage, tourState, setAccessPermissions}) => {
  const auth = useAuth();
  const theme = useTheme();
  const [stepIndex, setStepIndex] = useState(tourState.index);

  const defaultOptions = {
    zIndex: 1500,
    arrowColor: theme.vars.palette.background.paper,
  };

  // delay the setting of the next step so that we are sure
  // components are rendered if we need to open/close things
  useEffect(() => {
    const stage = tourState.steps[tourState.index];
    const delay = stage && stage.delay ? stage.delay : 300;
    setTimeout(() => {
      setStepIndex(tourState.index);
    }, delay);
  }, [tourState.index, tourState.steps]);

  const onTourChange = data => {
    const {action, index, type, status, step} = data;

    if (
      action === ACTIONS.CLOSE ||
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status)
    ) {
      trackEvent(`Tour ended`, {
        status:
          status === STATUS.FINISHED || index + 1 === tourState.steps.length
            ? 'finished'
            : 'closed',
        step: index + 1,
      });

      if (step.onEnd) {
        step.onEnd();
      }
      endTour(tourState.tour);
      // revert initial setup of permissions filter
      if (tourState.tour === TOURS.MAIN) {
        setAccessPermissions(!isTrialUser(auth.user.claims));
      }
    } else if ([EVENTS.STEP_AFTER].includes(type)) {
      // Check whether next or back button click and update the step
      const newStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      setupTourStage(newStepIndex);
    }
  };

  return (
    <Joyride
      run={tourState.run}
      stepIndex={stepIndex}
      continuous
      disableCloseOnEsc
      disableOverlayClose
      steps={tourState.steps}
      tooltipComponent={TourCard}
      styles={{options: defaultOptions}}
      callback={onTourChange}
      floaterProps={{disableAnimation: true}}
    />
  );
};

Tour.propTypes = {
  endTour: PropTypes.func,
  setupTourStage: PropTypes.func,
  tourState: PropTypes.object,
  setAccessPermissions: PropTypes.func,
};

const mapStateToProps = state => ({
  tourState: state.tour,
});

const mapDispatchProps = {
  endTour,
  setupTourStage,
  setAccessPermissions,
};

export default connect(mapStateToProps, mapDispatchProps)(Tour);
